import { shareInFlight } from './shareInFlight';

const inFlight = new Map();

// Attendance data changes a few times a day, so an answer is reused for this long before asking the API again.
export const ATTENDANCE_CACHE_MS = 5 * 60 * 1000;

// Returns the answer stored under `key` while it is younger than `maxAgeMs`; otherwise runs `load` (sharing a
// request that is already running) and stores what it returns. Errors are not stored.
// Keys should start with a prefix PageLayout clears when another account signs in (e.g. "attendance_").
export function cachedRequest(key, maxAgeMs, load) {
  try {
    const stored = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (stored && Date.now() - stored.at < maxAgeMs) return Promise.resolve(stored.data);
  } catch {
    // unreadable entry: load again
  }
  return shareInFlight(inFlight, key, async () => {
    const data = await load();
    try {
      sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data }));
    } catch {
      // storage full or unavailable: still return the data
    }
    return data;
  });
}

// Returns whatever is stored under `key`, however old, or undefined. Used to paint a list at once while a fresh
// answer is loaded in the background (stale-while-revalidate).
export function readCachedValue(key) {
  try {
    const stored = JSON.parse(sessionStorage.getItem(key) || 'null');
    return stored ? stored.data : undefined;
  } catch {
    return undefined;
  }
}
